import { useMemo } from 'react';
import { defineMessages } from 'react-intl';
import { useCurrenciesContext, useSecuritiesContext } from '../../../../contexts';
import { useIntl } from '../../../../hooks';
import { IconName } from '../../../Icons';
import type { FilterableProperty } from '../types';
import {
  CURRENCY_OF_SYMBOL_FILTER_TOOLTIP,
  getCurrencyFilterOptions,
  securityMatchesCurrencies,
} from './symbolCurrencyBasePairFilters';

const messages = defineMessages({
  currency: {
    defaultMessage: 'Currency',
    id: 'Filters.FilterBuilder.filters.currency',
  },
});

export function useCurrencyOfSymbolFilter() {
  const { formatMessage } = useIntl();
  const { currenciesList } = useCurrenciesContext();
  const { securitiesBySymbol } = useSecuritiesContext();

  const options = useMemo(() => getCurrencyFilterOptions(currenciesList), [currenciesList]);

  return useMemo(
    () =>
      ({
        key: 'Currencies',
        field: 'Symbol',
        label: formatMessage(messages.currency),
        icon: IconName.CurrencyDollar,
        tooltip: CURRENCY_OF_SYMBOL_FILTER_TOOLTIP,
        options,
        clearUnsupportedSelectionsOnInit: false,
        getOptionLabel: (option: string) => option,
        fieldFilter: (symbol: string, selections: string[]) =>
          securityMatchesCurrencies(securitiesBySymbol.get(symbol), selections),
      }) as const satisfies FilterableProperty,
    [formatMessage, options, securitiesBySymbol]
  );
}
